import _ from 'lodash'
import * as d3 from 'd3'
import * as legend from 'd3-svg-legend'
import MethGlob from '@/utils/MetodosGlobais'

export default {
  name: 'Legenda',
  methods: {
    drawLegenda: drawLegenda,
    drawLegendaGradiente: drawLegendaGradiente,
    drawLegendaRetangularComGradiente: drawLegendaRetangularComGradiente,
  },
}
// Metodo de Definição de Legenda deve ser chamado dentro do lifecycle hook Mounted não antes.
function drawLegenda (el, colors, labels) {
  el.append('svg')
    .attr('id', 'legendaSVG')
    .append('g')
    .attr('class', 'legendOrdinal')
    .attr('transform', 'translate(20,20)')

  let ordinal = d3.scaleOrdinal()
    .domain(_.slice(labels, 1))
    .range(colors)

  let legendOrdinal = legend.legendColor()
    .shape('circle')
    .shapePadding(30)
    .shapeWidth(60)
    .orient('horizontal')
    .title(_.head(labels))
    .scale(ordinal)

  el.select('.legendOrdinal')
    .call(legendOrdinal)

  return el
}

function drawLegendaGradiente (el, colors, labels, comeco, final, largura, altura, legenda, ticks, font_size) {
  let w = 300
  let h = 50
  if (largura && largura > 0) {
    w = largura
  }
  if (altura && altura > 0) {
    h = altura
  }
  if (!legenda) {
    legenda = ''
  }

  // remove o elemento SVG dentro de EL.  <- Para a atualização correta da legenda caso o parametro do grafico/mapa mude.
  el.select('svg').remove()

  // insere um novo elemento SVG
  el.append('svg')
    .attr('id', 'legendaSVG')
    .attr('width', '100%')
    .attr('display', 'block')
    .attr('margin', 'auto')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .attr('viewBox', '0 0 ' + (w + 25) + ' ' + (h + 28))
    .append('g')
    .attr('class', 'legendOrdinal')
    .attr('transform', 'translate(20,10)')

  let key = el.select('.legendOrdinal')
    .append('svg')
    .attr('width', w)
    .attr('height', h + 20)

  let legend = key.append('defs')
    .append('svg:linearGradient')
    .attr('id', 'gradient')
    .attr('x1', '0%')
    .attr('y1', '100%')
    .attr('x2', '100%')
    .attr('y2', '100%')
    .attr('spreadMethod', 'pad')

  let posicao = 0
  colors.forEach(cor => {
    legend.append('stop')
      .attr('offset', posicao + '%')
      .attr('stop-color', cor)
      .attr('stop-opacity', 1)
    posicao += (100 / colors.length)
  })

  key.append('rect')
    .attr('width', w)
    .attr('height', h - 30)
    .style('fill', 'url(#gradient)')
    .attr('transform', 'translate(0,10)')

  let y = d3.scaleLinear()
    .domain([comeco, final])
    .range([0, w - 20])
    .nice()

  let yAxis = d3.axisBottom()
    .scale(y)
    .tickFormat((v) => { return v.toLocaleString('pt-BR') })
    .tickSize(3)
  if (ticks) yAxis.ticks(ticks)
  key.append('g')
    .style('font-size', (font_size || '0.6') + 'rem')
    .attr('transform', 'translate(2,30)')
    .call(yAxis)
    .append('text')
    .attr('x', w / 2)
    .attr('y', 25)
    .attr('dy', '.6rem')
    .style('text-anchor', 'middle')
    .style('fill', 'currentColor')
    .text(legenda)

  key.select('.domain').remove()

  return el
}

function drawLegendaGradiente2 (el, colors, labels, domain, largura, altura, legenda, ticks, font_size) {
  let w = 280
  let h = 50
  if (largura && largura > 0) {
    w = largura
  }
  if (altura && altura > 0) {
    h = altura
  }
  if (!legenda) {
    legenda = ''
  }

  // remove o elemento SVG dentro de EL.  <- Para a atualização correta da legenda caso o parametro do grafico/mapa mude.
  el.select('svg').remove()

  // insere um novo elemento SVG
  el.append('svg')
    .attr('id', 'legendaSVG')
    .attr('width', '98%')
    .attr('display', 'block')
    .attr('margin', 'auto')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .attr('viewBox', '0 0 ' + (w + 25) + ' ' + (h + 23))
    .append('g')
    .attr('class', 'legendOrdinal')
    .attr('transform', 'translate(20,10)')

  let key = el.select('.legendOrdinal')
    .append('svg')
    .attr('width', w)
    .attr('height', h + 20)

  let legend = key.append('defs')
    .append('svg:linearGradient')
    .attr('id', 'gradient')
    .attr('x1', '0%')
    .attr('y1', '100%')
    .attr('x2', '100%')
    .attr('y2', '100%')
    .attr('spreadMethod', 'pad')

  let posicao = 0
  colors.forEach(cor => {
    legend.append('stop')
      .attr('offset', posicao + '%')
      .attr('stop-color', cor)
      .attr('stop-opacity', 1)
    posicao += (100 / colors.length)
  })

  key.append('rect')
    .attr('width', w)
    .attr('height', h - 30)
    .style('fill', 'url(#gradient)')
    .attr('transform', 'translate(0,10)')

  let y = d3.scaleLinear()
    .domain(domain)
    .range([0, w - 20])
    .nice()

  let yAxis = d3.axisBottom()
    .scale(y)
    .tickFormat((v) => { return v.toLocaleString('pt-BR') })
    .tickSize(3)
    .tickValue(domain)
  if (ticks) yAxis.ticks(ticks)
  key.append('g')
    .style('font-size', (font_size || '0.6') + 'rem')
    .attr('transform', 'translate(2,30)')
    .call(yAxis)
    .append('text')
    .attr('x', w / 2)
    .attr('y', 25)
    .attr('dy', '.6rem')
    .style('text-anchor', 'middle')
    .style('fill', 'currentColor')
    .text(labels)

  key.select('.domain').remove()

  return el
}

// WIP - Criar legenda que reflita a escala dos dados
function drawLegendaRetangularComGradiente (el, data, colorArray, titulo) {
  let w = (d3.select('#legenda')._groups[0][0].clientWidth)
  let h = 30
  let Q = [data.min, _.mean(data.domain), data.max]

  let colorScale = d3.scaleLog()
    .domain(Q)
    .range(colorArray)
    .interpolate(d3.interpolateRgb)

  // append a defs (for definition) element to your SVG
  el.select('svg').remove()
  let svgLegend = el.append('svg')
    .attr('id', 'legendaSVG')
    .attr('viewBox', '0 0 ' + w + ' ' + (h))
    .attr('width', '100%')
    // .attr('height', '50%')
    .attr('display', 'block')
    .attr('margin', 'auto')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .append('g')
    .attr('class', 'legendOrdinal')
    .attr('transform', 'translate(0,2)')

  // append a linearGradient element to the defs and give it a unique id
  // and define a horizontal gradient
  let linearGradient = svgLegend.append('defs')
    .append('svg:linearGradient')
    .attr('id', 'linear-gradient')
    .attr('x1', '0%')
    .attr('y1', '0%')
    .attr('x2', '100%')
    .attr('y2', '0%')
    .attr('spreadMethod', 'pad')

  // append multiple color stops by using D3's data/enter step
  linearGradient.selectAll('stop')
    .data(colorScale.domain())
    .enter().append('stop')
    .attr('offset', function (d) {
      return d + '%'
    })
    .attr('stop-color', function (d) {
      return colorScale(d)
    })

  // svgLegend.append('text')
  //   .attr('class', 'legendTitle')
  //   .attr('transform', 'translate(0,10)')
  //   .attr('text-transform', 'none')
  //   .style('text-anchor', 'left')
  //   .attr('font-weight', '300')
  //   .attr('font-size', '.5vh')
  //   .attr('letter-spacing', '0.0375em')
  //   .style('color', '#34495e')
  //   .attr('font-family', 'Source Sans Pro Semibold, sans-serif')
  //   .text(titulo)

  // draw the rectangle and fill with gradient
  svgLegend.append('rect')
    .attr('width', '100%')
    .attr('height', '5px')
    .style('fill', 'url(#linear-gradient)')
    .attr('transform', 'translate(0,5)')

  // create tick marks
  let xLeg = d3.scaleLinear()
    .domain([data.min, data.max])
    .range([1, w - 3], 0.1)
    .nice()

  let axisLeg = d3.axisBottom(xLeg)
    .tickValues(data.uniqDomain)
    .tickFormat((v) => { return v.toLocaleString('pt-BR') })
    .tickSize(2)
    .tickPadding(3)

  svgLegend
    .attr('class', 'axis')
    .append('g')
    .attr('transform', 'translate(0, 10)')
    .style('font-size', 3)
    .call(axisLeg)
    .append('text')
    .attr('x', w / 2)
    .attr('dy', '.6rem')
    .style('text-anchor', 'middle')
    .style('fill', 'currentColor')
    .text(titulo)

  svgLegend.select('.domain').remove()

  return svgLegend
}
